import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getToken } from "../../utils/utility";
import { notification } from "antd";
import {
  getAllMenuItemsRequest,
  getAllCategoriesRequest,
  editMenuItemRequest,
  editCategoryRequest,
  syncMenuConfigurationImagesRequest,
  getMenuItemImageRequest,
  getAllItemsTagsRequest,
  editTagRequest,
  updateMenuItemImagesRequest,
} from "../../services/menuConfigurationService";

export function* getAllMenuItems({
  organizationId,
  restaurantId,
  defaultOrganizatoinLanguage,
}) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getAllMenuItemsRequest,
      token,
      organizationId,
      restaurantId,
      defaultOrganizatoinLanguage
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_MENU_ITEMS_SUCCESS,
        menuItems: response[1]?.sort(
          (x, y) => y.itemSortIndex - x.itemSortIndex
        ),
        organizationId,
        restaurantId,
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на Меню",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Меню",
    });
  }
}

export function* getAllCategories({ organizationId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllCategoriesRequest, token, organizationId);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_CATEGORIES_SUCCESS,
        categories: response[1],
        organizationId,
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на Меню",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Меню",
    });
  }
}

export function* editMenuItem({ menuItem }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(editMenuItemRequest, token, menuItem);

    if (response[0] === 200) {
      yield put({
        type: actions.EDIT_MENU_ITEMS_SUCCESS,
      });
      yield put({
        type: actions.RELOAD_MENU_ITEMS_STATE,
      });
      notification["success"]({
        message: "Успешно промяна",
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на Меню",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Меню",
    });
  }
}

export function* editCategory({ category }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(editCategoryRequest, token, category);

    if (response[0] === 200) {
      yield put({
        type: actions.EDIT_CATEGORY_SUCCESS,
      });
      yield put({
        type: actions.RELOAD_CATEGORIES_STATE,
      });
      notification["success"]({
        message: "Успешно промяна",
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на Меню",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Меню",
    });
  }
}

export function* syncMenuConfigurationImages({ organizationId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      syncMenuConfigurationImagesRequest,
      token,
      organizationId
    );
    if (response[0] === 200) {
      yield put({
        type: actions.SYNC_MENU_CONFIGURATION_IMAGES_SUCCESS,
        syncImageInProgress: false,
      });
      notification["success"]({
        message: "Успешно обновихте менюто",
      });
    } else {
      notification["error"]({
        message: "Неуспешно опресняване",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно опресняване",
    });
  }
}

export function* getMenuItemImage({ organizationId, itemId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getMenuItemImageRequest,
      token,
      organizationId,
      itemId
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_MENU_ITEM_IMAGE_SUCCESS,
        menuItemImage: response[1],
      });
    } else if (response[0] === 404) {
      yield put({
        type: actions.GET_MENU_ITEM_IMAGE_SUCCESS,
        menuItemImage: { imagePath: null },
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Снимка",
    });
  }
}

export function* getAllItemsTags({ organizationId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllItemsTagsRequest, token, organizationId);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ITEMS_TAGS_SUCCESS,
        itemsTags: response[1],
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на Тагове",
    });
  }
}

export function* editTag({ tag }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(editTagRequest, token, tag);
    if (response[0] === 200) {
      notification["success"]({
        message: "Успешно редактиране",
      });
      yield put({
        type: actions.RELOAD_ITEMS_TAGS_STATE,
      });
    } else {
      notification["error"]({
        message: "Неуспешно редактиране",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно редактиране",
    });
  }
}

export function* updateMenuItemImages({ imagesState }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      updateMenuItemImagesRequest,
      token,
      imagesState
    );
    if (response[0] === 200) {
      // notification["success"]({
      //   message: "Успешно редактиране",
      // });
    } else {
      notification["error"]({
        message: "Неуспешно редактиране",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно редактиране",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_MENU_ITEMS_REQUEST, getAllMenuItems),
    yield takeEvery(actions.GET_CATEGORIES_REQUEST, getAllCategories),
    yield takeEvery(actions.EDIT_MENU_ITEMS_REQUEST, editMenuItem),
    yield takeEvery(actions.EDIT_CATEGORY_REQUEST, editCategory),
    yield takeEvery(
      actions.SYNC_MENU_CONFIGURATION_IMAGES_REQUEST,
      syncMenuConfigurationImages
    ),
    yield takeEvery(actions.GET_MENU_ITEM_IMAGE_REQUEST, getMenuItemImage),
    yield takeEvery(actions.GET_ITEMS_TAGS_REQUEST, getAllItemsTags),
    yield takeEvery(actions.EDIT_TAG_REQUEST, editTag),
    yield takeEvery(
      actions.UPDATE_MENU_ITEMS_IMAGES_REQUEST,
      updateMenuItemImages
    ),
  ]);
}
